{
  "heading": "Campanion Admin — Terms of Service",
  "intro": "These terms of service apply to Campanion Admin, the camp administration web application provided by Campminder. By using Campanion Admin, you agree to these terms.",
  "iframeTitle": "Campanion Admin Terms of Service"
}
